import Scratch from './scratch';
import ScratchPage from './scratch-page';
export {ScratchPage};
export default Scratch;
